import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";
import { ChartDefinition } from "../../chartDefinitions.config";

@Component({
  selector: "chart-details-layout",
  templateUrl: "./chart-details-layout.component.html",
  styleUrl: "./chart-details-layout.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChartDetailsLayoutComponent {
  @Input() chartDetails: ChartDefinition | undefined;
  @Input() isLoading: boolean = true;
  @Input() showChartOrGrid: boolean = true;
  @Input() showFormButtons: boolean;
  @Output() save = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  isCollapsed: boolean = false;
  panelWidth: number = 450; // Default panel width
  collapseTooltip: string = this.isCollapsed ? "Expand" : "Collapse";
  resizing: boolean = false;

  constructor() {}

  saveSettings(): void {
    this.save.emit();
  }

  revertSettings(): void {
    this.cancel.emit();
  }

  togglePanel(): void {
    this.resizing = true;
    this.isCollapsed = !this.isCollapsed;
    setTimeout(() => {
      this.resizing = false;
    }, 500);
  }

  startResizing(event: MouseEvent): void {
    this.resizing = true;
    event.preventDefault();
  }

  @HostListener("window:mousemove", ["$event"])
  onResizing(event: MouseEvent): void {
    if (this.resizing) {
      const newWidth =
        document.querySelector(".settings-panel")?.getBoundingClientRect()
          .right! - event.clientX;
      if (newWidth > 100 && newWidth < 900) {
        this.panelWidth = newWidth;
      }
    }
  }

  @HostListener("window:mouseup", ["$event"])
  stopResizing(): void {
    this.resizing = false;
  }
}
